export const PRODUCT_TYPES = Object.freeze({
  GI_TAGS: {
    id: "gi_tags",
    label: "GI Tags",
    value: "GI_TAGS",
  },
  SHARKTANK: {
    id: "sharktank",
    label: "Shark Tank",
    value: "SHARKTANK",
  },
  HANDMADE: {
    id: "handmade",
    label: "Handmade",
    value: "HANDMADE",
  },
  ART: {
    id: "art",
    label: "Art",
    value: "ART",
  },
  HANDICRAFTS: {
    id: "handicrafts",
    label: "Handicrafts",
    value: "HANDICRAFTS",
  },
  CLOTHING: {
    id: "clothing",
    label: "Clothing",
    value: "CLOTHING",
  },
  JEWELRY: {
    id: "jewelry",
    label: "Jewelry",
    value: "JEWELRY",
  },
  ELECTRONICS: {
    id: "electronics",
    label: "Electronics",
    value: "ELECTRONICS",
  },
  FOOD: {
    id: "food",
    label: "Food",
    value: "FOOD",
  },
  HOME_DECOR: {
    id: "home_decor",
    label: "Home Decor",
    value: "HOME_DECOR",
  },
  APPAREL: {
    id: "apparel",
    label: "Apparel",
    value: "APPAREL",
  },
  BOOKS: {
    id: "books",
    label: "Books",
    value: "BOOKS",
  },
  SPORTS: {
    id: "sports",
    label: "Sports",
    value: "SPORTS",
  },
  BEAUTY: {
    id: "beauty",
    label: "Beauty",
    value: "BEAUTY",
  },
  TOYS: {
    id: "toys",
    label: "Toys",
    value: "TOYS",
  },
  FURNITURE: {
    id: "furniture",
    label: "Furniture",
    value: "FURNITURE",
  },
  AUTOMOTIVE: {
    id: "automotive",
    label: "Automotive",
    value: "AUTOMOTIVE",
  },
  GARDEN: {
    id: "garden",
    label: "Garden",
    value: "GARDEN",
  },
  PET_SUPPLIES: {
    id: "pet_supplies",
    label: "Pet Supplies",
    value: "PET_SUPPLIES",
  },
  HEALTH: {
    id: "health",
    label: "Health",
    value: "HEALTH",
  },
  MUSIC: {
    id: "music",
    label: "Music",
    value: "MUSIC",
  },
  OFFICE_SUPPLIES: {
    id: "office_supplies",
    label: "Office Supplies",
    value: "OFFICE_SUPPLIES",
  },
  SOFTWARE: {
    id: "software",
    label: "Software",
    value: "SOFTWARE",
  },
  OTHER: {
    id: "other",
    label: "Other",
    value: "OTHER",
  },
});

// Helper function to get array of all product types
export const getProductTypesList = () => Object.values(PRODUCT_TYPES);

// Helper function to get product type by value
export const getProductTypeByValue = (value) => {
  return Object.values(PRODUCT_TYPES).find((type) => type.value === value);
};

// Helper function to get product type by id
export const getProductTypeById = (id) => {
  return Object.values(PRODUCT_TYPES).find((type) => type.id === id);
};

export const DISCOUNT_TYPE_CATEGORY = {
  excludeProductType: "excludeProductType",
  includeProductType: "includeProductType",
  excludeProductByNameIncludes: "excludeProductByNameIncludes",
};

export const ANIMATION_URLS = {
  orderFullfilment:
    "https://lottie.host/e241d5eb-22b2-45f4-bf0c-a6e0300caa72/Avv4dc75a3.lottie",
};
